import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function setMerchantDetailsReducer(state = initialState.merchantDetails.merchantDetails, action) {
  switch (action.type) {
    case types.SET_MERCHANT_DETAILS:
      return Object.assign({}, state, {
        merchantDetails: action.merchantDetails,
      });
    default:
      return state;
  }
}
